import React, { useState } from "react";
import {
  Card,
  CardBody,
  Row,
  Col,
  FormGroup,
  Label,
  Button,
} from "reactstrap";
import { useMutation } from "@apollo/client";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import {
  HOSPITAL_CREATE_MUTATION,
  HOSPITAL_LIST_QUERY,
} from "../../config/Queries";
import { toast } from "react-toastify";

function HospitalWrite() {
  const history = useHistory();
  const [logoFile, setLogoFile] = useState(null);
  const [imageFiles, setImageFiles] = useState([]);
  const [createHospitalMutation] = useMutation(HOSPITAL_CREATE_MUTATION, {
    refetchQueries: [{ query: HOSPITAL_LIST_QUERY }],
  });
  const { register, handleSubmit } = useForm();

  const onSubmit = async (data) => {
    try {
      const {
        data: { createHospital },
      } = await createHospitalMutation({
        variables: {
          name: data.name,
          tags: data.tags || null,
          greeting: data.greeting || null,
          address: data.address || null,
          phone: data.phone || null,
          latitude: data.latitude ? parseFloat(data.latitude) : null,
          longitude: data.longitude ? parseFloat(data.longitude) : null,
          logo: logoFile,
          images: imageFiles.length ? imageFiles : null,
        },
      });

      if (!createHospital?.ok) {
        toast.error(createHospital?.error || "병원 등록에 실패했습니다.");
        return;
      }

      toast.success("병원 등록이 완료되었습니다.");
      history.push("/admin/hospitals");
    } catch (e) {
      console.log(e);
      toast.error("병원 등록 중 오류가 발생했습니다.");
    }
  };

  return (
    <div className="content">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Card>
          <div className="card-heading">병원 정보</div>
          <CardBody>
            <FormGroup row>
              <Label sm={2}>병원명</Label>
              <Col sm={10}>
                <input
                  className="form-control"
                  placeholder="병원명"
                  ref={register({ required: true })}
                  name="name"
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={2}>태그</Label>
              <Col sm={10}>
                <input
                  className="form-control"
                  placeholder="예: 요양병원, 응급대기"
                  ref={register}
                  name="tags"
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={2}>인사말</Label>
              <Col sm={10}>
                <textarea
                  className="form-control"
                  style={{ minHeight: 120 }}
                  placeholder="병원 소개"
                  ref={register}
                  name="greeting"
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={2}>주소</Label>
              <Col sm={10}>
                <input
                  className="form-control"
                  placeholder="주소"
                  ref={register}
                  name="address"
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={2}>전화번호</Label>
              <Col sm={10}>
                <input
                  className="form-control"
                  placeholder="전화번호"
                  ref={register}
                  name="phone"
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={2}>위도</Label>
              <Col sm={4}>
                <input
                  className="form-control"
                  placeholder="36.341743"
                  ref={register}
                  name="latitude"
                  type="number"
                  step="any"
                />
              </Col>
              <Label sm={2}>경도</Label>
              <Col sm={4}>
                <input
                  className="form-control"
                  placeholder="127.389674"
                  ref={register}
                  name="longitude"
                  type="number"
                  step="any"
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={2}>로고</Label>
              <Col sm={10}>
                <input
                  type="file"
                  accept="image/*"
                  className="form-control"
                  onChange={(e) => setLogoFile(e.target.files?.[0] || null)}
                />
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={2}>병원 사진</Label>
              <Col sm={10}>
                <input
                  type="file"
                  accept="image/*"
                  multiple
                  className="form-control"
                  onChange={(e) =>
                    setImageFiles(
                      e.target.files ? Array.from(e.target.files) : []
                    )
                  }
                />
                {imageFiles.length > 0 && (
                  <small className="text-muted">
                    {imageFiles.length}개 파일 선택됨
                  </small>
                )}
              </Col>
            </FormGroup>
          </CardBody>
        </Card>
        <Row>
          <Col xs={4}>
            <Button
              type="button"
              className="btn-white"
              onClick={() => history.push("/admin/hospitals")}
            >
              <i className="fa fa-list"></i> 목록
            </Button>
          </Col>
          <Col xs={4} className="text-center">
            <Button type="submit" className="btn-inverse">
              <i className="fa fa-check"></i> 등록
            </Button>
          </Col>
        </Row>
      </form>
    </div>
  );
}

export default HospitalWrite;
